import {
  Alert,
  Box,
  CircularProgress,
  FormControlLabel,
  Switch,
  Typography,
} from "@mui/material";
import { useEffect } from "react";

import messages from "../../public/locales/en/admin.json";
import { useAppDispatch, useAppSelector } from "../store";
import {
  fetchRegistrationSettings,
  saveRegistrationSettings,
} from "../store/slices/registrationSettingsSlice";

import type { ReactElement } from "react";

export default function RegistrationSettings(): ReactElement {
  const dispatch = useAppDispatch();
  const { settings, loading, saving, error } = useAppSelector(
    (state) => state.registrationSettings,
  );
  const copy = messages.admin.settings.registration;

  useEffect(() => {
    void dispatch(fetchRegistrationSettings());
  }, [dispatch]);

  return (
    <Box>
      {error && (
        <Alert severity="error">
          {messages.admin.settings.messages.saveFailed}
        </Alert>
      )}
      <FormControlLabel
        control={
          <Switch
            checked={settings?.registrationEnabled ?? false}
            disabled={loading || saving || settings === null}
            onChange={(_event, checked): void => {
              void dispatch(
                saveRegistrationSettings({ registrationEnabled: checked }),
              );
            }}
          />
        }
        label={copy.label}
      />
      {(loading || saving) && <CircularProgress size={16} />}
      <Typography variant="body2" color="text.secondary">
        {copy.description}
      </Typography>
    </Box>
  );
}
